// extracted by mini-css-extract-plugin
export default {"credit-subtitle-container":"mYunFb","creditSubtitleContainer":"mYunFb","credit-text":"cZRbBX","creditText":"cZRbBX","credit-no-sale":"XVRvx9","creditNoSale":"XVRvx9"};